class CartProgress extends HTMLElement {
  constructor() {
    super();
    this.giftVariantId = this.dataset.giftVariantId;
    this.giftTwoVariantId = this.dataset.giftTwoVariantId;
    this.giftProductId = this.dataset.giftProductId;
    this.giftTwoProductId = this.dataset.giftTwoProductId;
    this.thresholdOne = parseFloat(this.dataset.threshold);
    this.thresholdTwo = parseFloat(this.dataset.thresholdTwo);
    this.giftType = this.dataset.giftType;
    this.cartForm = document.querySelector('cart-items');
  }

  connectedCallback() {
    this.addButtons = this.querySelectorAll('[data-add-gift]');
    if (this.addButtons) {
      this.addButtons.forEach((button) => {
        button.removeEventListener('click', this._freeGiftAddToCart);
        button.addEventListener('click', (event) => this._freeGiftAddToCart(event, button));
      })
    }

    this.addEventListener('change', (event) => {
      const variantSelector = event.target.classList.contains('cart-progress__free-product--variant-select') ?
        event.target :
        event.target.closest('.cart-progress__free-product--variant-select');

      if (variantSelector) {
        this._updateVariant(event, variantSelector);
      }
    });
  }
  
  _updateElement(cart) {
    const sectionId = document.querySelector('#main-cart-items').dataset.id
    const source = cart.sections[sectionId];
    const sourceCart = document.createElement('div');
    sourceCart.innerHTML = source;
    
    const sourceMessage = sourceCart.querySelector('[data-cart-message]');
    const targetMessage = document.querySelector('[data-cart-message]');
    if(sourceMessage && targetMessage) {
      targetMessage.innerHTML = sourceMessage.innerHTML;
    }

    const sourceBar = sourceCart.querySelector('[data-bar-progress]');
    const targetBar = document.querySelector('[data-bar-progress]');
    if(sourceBar && targetBar) {
      const styles = sourceBar.getAttribute('style');
      if(styles) {
        targetBar.setAttribute('style', styles);
      }
    }

    const sourceGiftProducts = sourceCart.querySelector('[data-gift-products]');
    const targetGiftProducts = document.querySelector('[data-gift-products]');
    if(sourceGiftProducts && targetGiftProducts) {
      targetGiftProducts.innerHTML = sourceGiftProducts.innerHTML;
      this.connectedCallback();
    }
  }

  _updateVariant(event, selector) {
    const parent = event.target.closest('.cart-progress__free-product');
    const id = event.target.value;
    const addToCartButton = parent.querySelector('.cart-progress__free-product--add');
    const images = parent.querySelectorAll('.free-product__image-variant');
    const variantImage = parent.querySelector(`#variant-image--${id}`);

    images.forEach(img => img.style.opacity = 0);
    variantImage.style.opacity = 1;
    addToCartButton.removeAttribute('disabled')
  }

  async _getCart() {
    try {
      const response = await fetch(`${routes.cart_url}.js`);
      if (!response.ok) {
          throw new Error(`Network response was not ok: ${response.status} ${response.statusText}`);
      }
      const cart = await response.json();
      console.log('Cart fetched successfully:', cart); // Log the cart data
      return cart;
    } catch (error) {
      console.error('Failed to fetch cart:', error); // Log the error details
      return null;
    }
}
  
  async testThreshold(cart) {
    if (!cart) {
      this.cart = await this._getCart();
    } else {
      this.cart = cart;
      this._updateElement(cart);
    }

    console.log(this.cart)

    if(this.cart !== null) {
      this.cartTotal = this.cart.total_price;
      this.giftInCartOne = this.cart.items.filter((item) => item.product_id == this.giftProductId);
      this.giftInCartTwo = this.cart.items.filter((item) => item.product_id == this.giftTwoProductId);

      let updates = {};

      console.log(this.cartTotal, this.thresholdOne, this.thresholdTwo, this.giftInCartTwo.length, this.giftInCartOne.length)
      
      if(this.cartTotal < this.thresholdOne && this.giftInCartOne.length) {
        updates[this.giftInCartOne[0].variant_id] = 0
      }
      if(this.cartTotal < this.thresholdTwo && this.giftInCartTwo.length){
        updates[this.giftInCartTwo[0].variant_id] = 0
      }
      
      if(this.giftType === "automatic") {
        if(this.cartTotal >= this.thresholdOne && !this.giftInCartOne.length) {
          updates[this.giftVariantId] = 1
        }
        if(this.cartTotal >= this.thresholdTwo && !this.giftInCartTwo.length) {
          updates[this.giftTwoVariantId] = 1
        }
      }

      this._autoAddToCart(updates)
    }
  }

  _autoAddToCart(updates) {
    console.log(updates)
    if (Object.keys(updates).length > 0) {
      const formData = {
        updates,
        sections_url: window.location.pathname
      };

      if(this.cartForm) formData.sections = this.getSectionsToRender().map((section) => section.section)
    
      fetch(`${routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
        .then((response) => response.json())
        .then((response) => {
          if(this.cartForm) {
            this.renderContents(response)
          } else {
            this._showSuccess(response)
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  _showSuccess(response, parent) {
    if(parent) parent.style.display = 'none';
    const successMessage = document.querySelector('[data-success]');
    const giftTitle = response.items[0].title;
    const giftTitleWrapper = successMessage.querySelector('[data-gift-title');
    console.log(successMessage, giftTitle)
    if(successMessage && giftTitle) {
      successMessage.style.display = 'inline';
      giftTitleWrapper.innerText = giftTitle;
    }
  }
  
  _freeGiftAddToCart(event, button) {
    event.preventDefault();
    button.setAttribute('disabled', 'disabled');
  
    const parent = event.target.closest('.cart-progress__free-product');
    const input = parent.querySelector('[name="variant"]');
    const variantId = input.value;
    const giftNumber = parent.dataset.gift;
  
    const giftInCart = document.querySelector('[data-gift-item]');
    let formData;
  
    if (giftInCart) {
      const existingVariantId = giftInCart.dataset.giftId;
  
      formData = {
        updates: {
          [variantId]: 1,
          [existingVariantId]: 0
        },
        sections_url: window.location.pathname
      };
    } else {
      formData = {
        updates: {
          [variantId]: 1
        },
        sections_url: window.location.pathname
      };
    }

    if(this.cartForm) formData.sections = this.getSectionsToRender().map((section) => section.section)
  
    if (!button.classList.contains('loading')) {
      button.setAttribute('aria-disabled', true);
      button.classList.add('loading');
    }
  
    fetch(`${routes.cart_update_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then((response) => response.json())
    .then((response) => {
      if(this.cartForm) {
        this.renderContents(response)
      }
      this._showSuccess(response, parent)
    })
    .catch((e) => {
      console.error(e);
    });
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section => {
      if (!document.getElementById(section.id)) {
        return;
      }
      const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

      if (typeof CartDrawer !== 'undefined') {
        new CartDrawer();
      }
      if (typeof Cart !== 'undefined') {
        new Cart().renderContents(parsedState);
      }
    }));
  }
  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

};
window.customElements.define('cart-progress', CartProgress);

